{
  "Add to profile": "Lägg till i Avslutade",
  "What did I learn": "Vad lärde jag mig",
  "Time spent": "tid",
  "Learning has been added": "Lärande har lagts till",
  "Learning has been updated": "Lärande har uppdaterats",
  "Learning has been removed": "Lärande har tagits bort",
  "Provided time is not valid": "Den angivna tiden är inte giltig",
  "Link needs to be a valid URL": "Länken måste vara en giltig URL",
  "Provided time must be greater or equal to 0": "Den angivna tiden måste vara större eller lika med 0",
  "Provided time must be less than or equal to 50 hours": "Den angivna tiden måste vara mindre eller lika med 50 timmar",
  "Provided time must be an integer": "Den angivna tiden måste vara ett heltal",
  "Type": "Lärtyp"
}
